import { createMessage } from 'apis/AiChat/AiChat';
import { useMutation, useQueryClient } from 'react-query';
import { CreateMessagePayload } from 'types';
import { addMessageToChatHistory } from './addMessageToChatHistory';

export const useCreateMessage = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (payload: CreateMessagePayload) => {
      const { chatId, content, actionType, contentType } = payload;

      return createMessage(chatId, { content, actionType, contentType });
    },
    {
      retry: false,
      onSuccess: data => {
        addMessageToChatHistory({
          queryClient,
          chatId: data.aiChatId,
          message: data,
        });
      },
    },
  );
};
